<template>
  <a
    class="rs-listing__card"
    :href="post.permalink"
    :lang="post.lang"
    :hreflang="post.lang"
    :dir="post.lang_dir"
  >
    <div class="rs-listing__card__image">
      <div v-if="post.post_type === 'rs_video'">
        <svg
          class="rs-video-listing__card__image__playicon"
          width="60"
          height="60"
          viewBox="0 0 68 47.812"
        >
          <g transform="translate(-6724 -9005)">
            <path
              id="outer"
              d="M81.512,71.481A8.544,8.544,0,0,0,75.5,65.43C70.2,64,48.933,64,48.933,64s-21.264,0-26.567,1.43a8.544,8.544,0,0,0-6.012,6.051c-1.421,5.337-1.421,16.473-1.421,16.473s0,11.136,1.421,16.474a8.417,8.417,0,0,0,6.012,5.954c5.3,1.43,26.567,1.43,26.567,1.43s21.264,0,26.567-1.43a8.417,8.417,0,0,0,6.012-5.954c1.421-5.337,1.421-16.474,1.421-16.474S82.933,76.818,81.512,71.481ZM41.978,98.065V77.844L59.751,87.955,41.978,98.065Z"
              transform="translate(6709.067 8941)"
              fill="red"
            />
            <path
              id="inner"
              d="M41.978,98.065V77.844L59.751,87.955,41.978,98.065Z"
              transform="translate(6709.067 8941)"
              fill="#fff"
            />
          </g>
        </svg>
      </div>
      <div v-if="post.featured_image" v-html="post.featured_image"></div>
      <div
        v-if="post.post_type === 'rs_ccfe'"
        class="rs-listing__card__image__ccfestamp"
      >
        <img
          width="92"
          src="/app/themes/rabbisacks2021/dist/images/covenant-conversation-family-edition-logo-dec2022.png"
          alt="Covenant &amp; Conversation Family Edition"
        />
      </div>
      <div
        v-if="post.post_type === 'rs_chaggim'"
        class="rs-listing__card__image__ccfestamp"
      >
        <img
          width="92"
          src="/app/themes/rabbisacks2021/dist/images/ceremony-celebration-family-edition-logo-dec2022.png"
          alt="Ceremony &amp; Celebration Family Edition"
        />
      </div>
    </div>
    <div class="rs-listing__card__categories">
      <span v-for="(parsha, i) in post.rs_cc_parsha" :key="parsha.slug">
        <span v-if="i > 0">, </span>
        <a :href="parsha.permalink" v-html="parsha.name"></a>
        <!-- <router-link
          :to="baseURL + parsha.slug + '/'"
          @click.native="$emit('scroll-to-top-request')"
          >{{ parsha.name }}</router-link
        > -->
      </span>
      <span v-if="post.rs_cc_parsha.length && post.rs_cc_year.length"> • </span>
      <span v-for="(year, i) in post.rs_cc_year" :key="year.id">
        <span v-if="i > 0">, </span>
        <a :href="year.permalink" v-html="year.name"></a>
        <!-- <router-link
          :to="baseURL + year.slug + '/'"
          @click.native="$emit('scroll-to-top-request')"
          >{{ year.name }}</router-link
        > -->
      </span>
    </div>
    <div class="rs-listing__card__title" v-html="post.post_title"></div>
    <div class="rs-listing__card__description" v-html="post.post_excerpt"></div>
    <div class="rs-listing__card__footer">
      <div class="rs-listing__card__footer__cta">
        <span v-if="post.lang === 'es'">Lea más &gt;</span>
        <span v-else-if="post.lang === 'fr'">Lire la suite &gt;</span>
        <span v-else-if="post.lang === 'he'">קרא עוד &gt;</span>
        <span v-else-if="post.post_type === 'rs_video'">Watch Video &gt;</span>
        <span v-else>Read More &gt;</span>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    baseURL: String,
    post: Object,
  },
};
</script>
